<template>
  <div class="lista-usuarios-grupo">
    <b-input-group class="mt-3 mb-3">
      <b-form-input placeholder="Search users" v-model="pesquisa"></b-form-input>
      <b-input-group-append>
        <b-button variant="light">

          <i class="fa fa-search fa-lg"></i>
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <b-list-group>
      <b-list-group-item
        v-for="u in usuarios"
        :key="u.id"
        class="d-flex justify-content-between align-items-center"
      >
        <div >

          <img
            :src="u.image ? u.image : 'https://www.pena.com.br/wp-content/uploads/2017/05/user-icon.jpg'"
            class="img-avatar mr-1 img-avatar-tamanho"
          />
          <span>{{ u.stNome }}</span>
          <br/>
          <span>{{ u.email }}</span>

        </div>
        <b-checkbox v-model="u.selecionado" @change="usuarioSelecionado">
                    <div v-if="u.online === true" class="greenBall"/>
          <div v-if="u.online === false" class="redBall"/>
        </b-checkbox>

      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      pesquisa: undefined,
    };
  },
  async created() {
    try {
      this.pesquisa = undefined;
      this.$emit('input', []);
      await this.listarUsuarios();
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    ...mapActions(['listarUsuarios']),
    usuarioSelecionado() {
      this.$nextTick(() => {
        this.$emit('input', this.usuarios.filter((u) => u.selecionado));
      });
    },
  },
  computed: {
    ...mapGetters(['usuariosSemUsuarioLogado', 'usuariosOnline']),
    usuarios() {
      this.usuariosSemUsuarioLogado.forEach((usuario) => {
        const res = this.usuariosOnline.find((user) => user.email === usuario.email);

        if (res) usuario.online = true;

        else usuario.online = false;
      });
      if (this.pesquisa) {
        return this.usuariosSemUsuarioLogado.filter((u) => u.nome.toUpperCase().includes(this.pesquisa.toUpperCase()));
      }
      return this.usuariosSemUsuarioLogado;
    },
  },
};
</script>

<style scoped>
.img-avatar-tamanho {
  height: 20px;
  width: 20px;
}
.icone-online {
  color: #62bd19;
  font-size: 10px;
  position: absolute;
  top: 5px;
  right: 5px;
}
.lista-usuarios-grupo {
  max-height: 400px;
  overflow-y: auto;
}

.redBall {
  float: right;
  width: 10px;
  height: 10px;
  background-color: red;
  border-radius: 50%
}

.greenBall {

  width: 10px;
  height: 10px;
  float: right;
  background-color: #62bd19;
  border-radius: 50%
}
</style>
